<!-- <div id="topMenuWrap" class="box">
  <img src="assets/img/AdmiralBET_-_Terminal_LOGO-01.png" class="logo" alt="Logo">
  <div class="menu-wrap">
    <a [routerLink]="['/betting', 'live']">Live</a>
  </div>
  <div *ngIf="!tmUser" class="log-contanet-wrap">
    <div class="log-contanet">
      <div class="input-wrap">
        <input type="text" class="form-control" placeholder="Username">
        <input type="text" class="form-control" placeholder="Password">
      </div>
      <button (click)="login()">LOGIN</button>
      <button class="register" (click)="register()">Register</button>
    </div>
    <div class="link" (click)="resetPass()">Forgot Password?</div>
  </div>
  <div *ngIf="tmUser">
    <button (click)="logOut()">Logout</button>
    <button (click)="account()">Account</button>
  </div>
</div> -->
<app-ticket-menager-header></app-ticket-menager-header>
<!-- <app-banner *ngIf="!isMobileView && viewConfigurations.showBannersDesktop"></app-banner>
<app-filter-navigation-menu [isLive]="false" *ngIf="(viewConfigurations.showFilterNavigationMenu && !isMobileView)"></app-filter-navigation-menu> -->

<!-- <div  class="results-title" *ngIf="pageType == pageTypeEnum.Results" i18n="Sport Tree Results Button@@SportTreeResults">Rezultati</div> -->
<div class="content-wrap" *ngIf="!(viewConfigurations.useMobileViewWithTopMenu && isMobileView)">
  <!-- <section class="left-content-wrap" [class.hide]="isMobileView && (hideMobileTree || expandedEvent)" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)"> -->
  <section class="left-content-wrap" [class.hide]="isMobileView && (hideMobileTree || expandedEvent)">
    <div id="leftContent">
      <app-search-events *ngIf="!viewConfigurations.showFilterNavigationMenu"></app-search-events>
      <ng-container *ngIf="pageType != pageTypeEnum.Results"><!--mozda ovde samo stavi da se uradi hide onog sto je selektovano-->
        <app-sportstree></app-sportstree>
      </ng-container>
      <ng-container *ngIf="pageType == pageTypeEnum.Results && resultTimeFilterValue != timeFilterValueEnum.None">
        <app-results-sports-tree [timeFilter]="resultTimeFilterValue"></app-results-sports-tree>
      </ng-container>
      <app-results-filter [pageType]="pageType" *ngIf="viewConfigurations.includeResultsPage" (filterValue)="selectResultsTimeFilter($event)"></app-results-filter>
    </div>
  </section>

  <section class="center-content-wrap">
    <!-- <section class="center-content-wrap" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)"> -->
    <div id="centerContent">
      <app-sports-tree-breadcrumbs
        *ngIf="pageTypeEnum.Prematch == pageType && isMobileView && hideMobileTree && !expandedEvent"
        [sport]="srcSelection.sport" [region]="srcSelection.region" [competition]="srcSelection.competition">
      </app-sports-tree-breadcrumbs>
      <ng-container
        *ngIf="pageType != pageTypeEnum.Results && (pageType == pageTypeEnum.Prematch || pageType == pageTypeEnum.MostPopular || pageType == pageTypeEnum.Soon) && (!isMobileView || hideMobileTree);">
        <!-- <app-events-banner [class.hide]="expandedEvent"></app-events-banner> -->
        <app-filter [class.hide]="expandedEvent" *ngIf="(!isMobileView && !viewConfigurations.showFilterNavigationMenu)" ></app-filter>
        <app-sport-tree-selection-container [class.hide]="expandedEvent"></app-sport-tree-selection-container>
      </ng-container>

      <ng-container *ngIf="pageType == pageTypeEnum.Results">
        <app-results-sports-selection-container [timeFilterValue]="resultTimeFilterValue" [class.hide]="expandedEventResult"></app-results-sports-selection-container>
        <app-results-event-details *ngIf="expandedEventResult" [expandedEventResult]="expandedEventResult"></app-results-event-details>
      </ng-container>

      <app-event-detail *ngIf="expandedEvent" [expandedEvent]="expandedEvent"></app-event-detail>
    </div>

  </section>

  <section class="right-content-wrap" >
    <div id="rightContent">
      <app-ticket-tools></app-ticket-tools>
      <app-streaming-wrap *ngIf="!expandedEvent"></app-streaming-wrap>
      <app-ticket></app-ticket>
      <!-- <app-promotion></app-promotion> -->
    </div>

  </section>
</div>

<!-- <app-notification-dialog></app-notification-dialog> -->
<app-head-to-head-widget *ngIf="showH2Hwidget" [betRadarEventId]="betRadarEventId"></app-head-to-head-widget>
<app-match-preview-widget *ngIf="showMPwidget" [betRadarEventId]="betRadarEventId"></app-match-preview-widget>

<app-ticket-dialog-mobile-v2 *ngIf="ticketDialogModel && viewConfigurations.showTicketDialogMobileV2 && isMobileView; else ticketDialogV1" [dialogModel]="ticketDialogModel"></app-ticket-dialog-mobile-v2 >
<ng-template #ticketDialogV1>
  <app-ticket-dialog *ngIf="ticketDialogModel" [dialogModel]="ticketDialogModel"></app-ticket-dialog>
</ng-template>
<app-loader [class.hide]="!loading"></app-loader>

<section class="mobile-wrap" *ngIf="viewConfigurations.useMobileViewWithTopMenu && isMobileView">
  <!-- <div class="color-palet-wrap">
    <div class="color-palet"></div>

    <div class="buttons">
      <button value="blue">blue</button>
      <button value="red">red</button>
      <button value="dark">dark</button>
      <button value="light">light</button>
    </div>
  </div> -->
  <div id="mobileContentWrap" class="mobile-content-wrap">
    <!-- <app-search-events [isLive]="pageType !== pageTypeEnum.Live"></app-search-events> -->
    <app-banner *ngIf="viewConfigurations.showBannersDesktop"></app-banner>
    <app-filter-mobile></app-filter-mobile>
    <app-search-events [isLive]="pageType === pageTypeEnum.Live ? true : false"></app-search-events>
    <app-sports-competition-tree-mobile *ngIf="pageType !== pageTypeEnum.Live && pageType !== pageTypeEnum.Results"></app-sports-competition-tree-mobile>
    <app-results-sport-competition-tree-mobile [timeFilter]="timeFilterValue"  *ngIf="pageType == pageTypeEnum.Results"></app-results-sport-competition-tree-mobile>
    <app-events-live-mobile *ngIf="pageType === pageTypeEnum.Live"></app-events-live-mobile>
    <app-event-live-detail-mobile *ngIf="expandedEvent" [expandedEvent]="expandedEvent"> </app-event-live-detail-mobile>
    <app-results-event-details-mobile *ngIf="expandedEventResult" [expandedEventResult]="expandedEventResult"></app-results-event-details-mobile>
  </div>
  <app-notification-dialog></app-notification-dialog>
  <app-ticket-mobile></app-ticket-mobile>

</section>
